// extracted by mini-css-extract-plugin
export default {"hidden":"aWg1so"};